module.exports = __webpack_public_path__ + "img/ring_r_c_1_1@3x.b8a4c036.png";